// Spec 007-vehicle-transfer-flow — useCancelTransfer.
// Mutation hook wrapping DELETE /v1/transfer/{transferId}.

import { apiFetch } from '@/lib/api';
import { TransferCancelResponseSchema } from '@/lib/schemas';
import type { TransferCancelResponse } from '@/types/api';
import { useMutation, type UseMutationResult } from '@tanstack/react-query';

export function useCancelTransfer(): UseMutationResult<TransferCancelResponse, Error, string> {
  return useMutation<TransferCancelResponse, Error, string>({
    mutationFn: (transferId) =>
      apiFetch<TransferCancelResponse>(`/v1/transfer/${transferId}`, {
        method: 'DELETE',
        schema: TransferCancelResponseSchema,
      }),
  });
}
